import { buildEditarExportacaoFormSteps, restoreTourDemoLayout } from './exportacaoTourSteps'

const buildEditarExportacaoTourSteps = (tourManager) => {
    tourManager.setTourCleanup(() => restoreTourDemoLayout())

    return [
        {
            popover: {
                title: 'Exportação de Dados',
                description: 'Para cadastrar um modelo de planilha para a exportação, acesse <strong>Parâmetros e Grupos</strong>. Defina os dados, as colunas, o cabeçalho e os grupos.<br><br>Se quiser gerar uma planilha usando um modelo já configurado, selecione o período desejado e clique em <strong>Gerar Relatório</strong>.',
                side: 'over',
                align: 'center',
            },
        },
        ...buildEditarExportacaoFormSteps(tourManager),
    ]
}

export default buildEditarExportacaoTourSteps
